export default __webpack_public_path__ + "static/media/hospital-marker.ea39db6d.png";